import { useQuery } from '@tanstack/react-query';
import { Navigate, Route, Routes } from 'react-router-dom';
import { api } from './api/client';
import { AppraisalWorksheetPage } from './pages/AppraisalWorksheet';
import { BlastComposerPage } from './pages/BlastComposer';
import { BlastDetailPage } from './pages/BlastDetail';
import { CockpitPage } from './pages/Cockpit';
import { DashboardPage } from './pages/Dashboard';
import { DealDetailPage } from './pages/DealDetail';
import { DealsBoardPage } from './pages/DealsBoard';
import { DealerDetailPage } from './pages/DealerDetail';
import { DealerFormPage } from './pages/DealerForm';
import { DealerImportPage } from './pages/DealerImport';
import { DealersListPage } from './pages/DealersList';
import { IntakeFormPage } from './pages/IntakeForm';
import { LiquidityTowerPage } from './pages/LiquidityTower';
import { LoginPage } from './pages/Login';
import { OfferBuilderPage } from './pages/OfferBuilder';
import { SpecReviewPage } from './pages/SpecReview';
import { SubmissionDetailPage } from './pages/SubmissionDetail';
import { SubmissionsListPage } from './pages/SubmissionsList';

export function App() {
  const meQuery = useQuery({ queryKey: ['me'], queryFn: api.me, retry: false });

  if (meQuery.isLoading) return <div className="center muted">Loading…</div>;
  const user = meQuery.data?.user ?? null;

  // Routes are gated: an unauthenticated operator is bounced to /login; a signed-in one that
  // lands on /login is sent home. All desk pages require a live operator session.
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/" element={user ? <DashboardPage user={user} /> : <Navigate to="/login" replace />} />
      <Route path="/submissions" element={user ? <SubmissionsListPage user={user} /> : <Navigate to="/login" replace />} />
      <Route
        path="/submissions/:id"
        element={user ? <SubmissionDetailPage user={user} /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/submissions/:id/valuation"
        element={user ? <AppraisalWorksheetPage user={user} /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/submissions/:id/blast"
        element={user ? <BlastComposerPage user={user} /> : <Navigate to="/login" replace />}
      />
      <Route path="/blasts/:id" element={user ? <BlastDetailPage user={user} /> : <Navigate to="/login" replace />} />
      <Route
        path="/submissions/:id/offers"
        element={user ? <OfferBuilderPage user={user} /> : <Navigate to="/login" replace />}
      />
      <Route path="/deals" element={user ? <DealsBoardPage user={user} /> : <Navigate to="/login" replace />} />
      <Route path="/deals/:id" element={user ? <DealDetailPage user={user} /> : <Navigate to="/login" replace />} />
      <Route
        path="/vehicles/:id/spec"
        element={user ? <SpecReviewPage user={user} /> : <Navigate to="/login" replace />}
      />
      <Route path="/dealers" element={user ? <DealersListPage user={user} /> : <Navigate to="/login" replace />} />
      <Route path="/dealers/new" element={user ? <DealerFormPage user={user} /> : <Navigate to="/login" replace />} />
      <Route path="/dealers/import" element={user ? <DealerImportPage user={user} /> : <Navigate to="/login" replace />} />
      <Route path="/dealers/:id" element={user ? <DealerDetailPage user={user} /> : <Navigate to="/login" replace />} />
      <Route path="/cockpit" element={user ? <CockpitPage user={user} /> : <Navigate to="/login" replace />} />
      <Route path="/liquidity" element={user ? <LiquidityTowerPage user={user} /> : <Navigate to="/login" replace />} />
      <Route path="/intake" element={user ? <IntakeFormPage user={user} /> : <Navigate to="/login" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
